module.exports = __webpack_public_path__ + "img/reynolds-logo.a053bd4c.png";